import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Paper, Typography } from "@mui/material";
import "./CookieConsent.css";
import CookieIcon from "@mui/icons-material/Cookie";

const GA_ID = "G-0BG7KPR1E4";
const STORAGE_KEY = "pa-cookie-consent"; // "accepted" | "rejected"

function loadGoogleAnalytics() {
  if (window.__gaLoaded) return;
  window.__gaLoaded = true;

  // Load gtag.js
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  // Init gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true });
}

export default function CookieHandler(){
  const [choice, setChoice] = React.useState(() => localStorage.getItem(STORAGE_KEY));

  React.useEffect(() => {
    if (choice === "accepted") loadGoogleAnalytics();
  }, [choice]);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setChoice("accepted");
  };

  const reject = () => {
    localStorage.setItem(STORAGE_KEY, "rejected");
    setChoice("rejected");
  };

  // If already chosen, don't show banner
  if (choice === "accepted" || choice === "rejected") return null;

  return (
    <div className="bws-cookieWrap" role="dialog" aria-live="polite" aria-label="Cookie consent">
      <Paper className="bws-cookieCard" elevation={0}>
        <div className="bws-cookieText">
          <div className="bws-cookieHeader">
            <CookieIcon className="bws-cookieIcon" />
            <Typography className="bws-cookieTitle">Cookies</Typography>
</div>

          <Typography className="bws-cookieBody">
            We use cookies to monitor website performance and to improve the user experience.
          </Typography>
          <Typography className="bws-cookieLinks">
            <RouterLink className="bws-privacyLink" to="/privacy">
              Privacy Policy
            </RouterLink>
          </Typography>
        </div>

        <div className="
        bws-cookieActions">
          <Button variant="contained" onClick={accept} sx={{minWidth:'80px'}}>
            Accept
          </Button>
          <Button variant="contained" onClick={reject} sx={{minWidth:'80px'}}>
            Reject
          </Button>
        </div>
      </Paper>
    </div>
  );
}

// import { React, useEffect, useRef } from "react";
// import { Link } from "react-router-dom"
// import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";
// import {useStyle} from '../../context/styleContext/styleContext'
// import ReactGA from 'react-ga4';
// const GOOGLE_ID = "G-0BG7KPR1E4"



// export default function CookieHandler(){

//   const consentGiven = getCookieConsentValue("CookieConsent");

//   const { style, setStyle } = useStyle();


//   if (consentGiven == "true") {
//     ReactGA.initialize(GOOGLE_ID)
//   }  

//   const  accept= () => {

//       ReactGA.initialize(GOOGLE_ID)
      
//   };
      

//   return (  
// <>
// <CookieConsent
//   location="bottom"
//   buttonText="Okay"
//   acceptOnScroll='true'
//   onAccept={(acceptedByScrolling) => {
//     if (acceptedByScrolling) {
//       // triggered if user scrolls past threshold
//     accept();
//     //alert("Accept was triggered by user scrolling");
//     } else {
//     accept();
//     //alert("Accept was triggered by clicking the Accept button");
//     }
//   }}
//   //cookieName="myAwesomeCookieName2"
//   style={{ background: style.color4, color:style.color1, minHeight:'10%', alignContent:'center'}}
//   buttonStyle={{ color: style.color4, fontSize: "16px", fontWeight:'bold', backgroundColor:style.color1 }}
//   expires={150}
  
// >
//   This website uses cookies to enhance the user experience.{" "}
// </CookieConsent>


// </>
    
//   )}

